import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import digitalCover from '../../assets/passports/digital-passport.webp';
import greenCover from '../../assets/passports/green-passport.webp';
import industrialCover from '../../assets/passports/industrial-passport.webp';
import entrepreneurialCover from '../../assets/passports/entrepreneurial-passport.webp';
import socialCover from '../../assets/passports/social-civic-passport.webp';
import interpersonalCover from '../../assets/passports/interpersonal-passport.webp';

const covers = {
  digital: digitalCover,
  green: greenCover,
  'industrial-occupational': industrialCover,
  entrepreneurial: entrepreneurialCover,
  'social-civic': socialCover,
  'dynamic-interpersonal': interpersonalCover
};
const beltOrder = ['white', 'yellow', 'orange', 'green', 'blue', 'purple', 'brown', 'black'];

export default function DashboardPassports({ passports }) {
  const startedCount = passports.filter(passport => passport.hasEvidence).length;

  return (
    <section className="learner-panel learner-passports" aria-labelledby="learner-passports-title">
      <header className="learner-panel-heading">
        <h2 id="learner-passports-title">Skills Passports</h2>
        <p>{startedCount} pathways started</p>
      </header>
      <div className="learner-passport-list">
        {passports.map(passport => (
          <details className={`learner-passport learner-passport--${passport.tone}`} key={passport.id}>
            <summary>
              <img className="learner-passport-cover" src={covers[passport.id]} alt="" loading="lazy" />
              <span className="learner-passport-summary">
                <strong>{passport.title}</strong>
                <span>{passport.statusLabel}{passport.progress !== null ? `, ${passport.progress}%` : ''}</span>
                {passport.progressionLabel ? <span className="learner-passport-target">{passport.progressionLabel}</span> : null}
              </span>
              <ChevronRightIcon className="learner-disclosure-icon" aria-hidden="true" />
            </summary>
            <div className="learner-passport-detail">
              <p className="learner-passport-level">{passport.levelLabel}</p>
              <p>{passport.description}</p>
              {Array.isArray(passport.standards) ? (
                <div className="learner-passport-standards" aria-label="Earned belt progress by standard">
                  <h3>Passport progress by Standard</h3>
                  {passport.standards.map(standard => (
                    <div className="learner-passport-standard" key={standard.standard}>
                      <strong>{standard.standard.charAt(0).toUpperCase() + standard.standard.slice(1)} Standard</strong>
                      <span>{standard.belt ? `${standard.belt.charAt(0).toUpperCase() + standard.belt.slice(1)} Belt` : 'Not started'}</span>
                      <span className={standard.standardComplete ? 'learner-passport-standard-complete' : ''}>
                        {standard.standardComplete
                          ? 'Complete'
                          : standard.belt === 'black'
                            ? 'Black Belt earned'
                            : standard.belt
                              ? `Next: ${beltOrder[beltOrder.indexOf(standard.belt) + 1].replace(/^[a-z]/, letter => letter.toUpperCase())} Belt`
                              : 'White Belt starts this Standard'}
                      </span>
                    </div>
                  ))}
                </div>
              ) : null}
              {passport.courseName ? <p><strong>Linked course:</strong> {passport.courseName}</p> : null}
              {passport.progress !== null ? (
                <div className="learner-passport-progress">
                  <div className="learner-passport-progress-label"><span>Course progress</span><strong>{passport.progress}%</strong></div>
                  <div className="learner-progress-track" role="progressbar" aria-label={`${passport.title} linked course progress`}
                    aria-valuemin={0} aria-valuemax={100} aria-valuenow={passport.progress}>
                    <span style={{ width: `${passport.progress}%` }} />
                  </div>
                </div>
              ) : null}
              <p className="learner-passport-next">{passport.nextStep}</p>
            </div>
          </details>
        ))}
      </div>
      <footer className="learner-panel-footer">
        <p>Course targets and earned belts are separate. Black Belt completes its own Standard after the linked assessment is passed.</p>
        <Link className="learner-text-link" to="/courses">Explore pathways <ArrowRightIcon aria-hidden="true" /></Link>
      </footer>
    </section>
  );
}
